"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceIdPrefix = exports.ResourceType = void 0;
// The enumeration value is aligned with the field resource_type of the database table `resource_changeset`, please do not modify it
var ResourceType;
(function (ResourceType) {
    ResourceType[ResourceType["Datasheet"] = 0] = "Datasheet";
    ResourceType[ResourceType["Form"] = 1] = "Form";
    ResourceType[ResourceType["Dashboard"] = 2] = "Dashboard";
    ResourceType[ResourceType["Widget"] = 3] = "Widget";
    ResourceType[ResourceType["Mirror"] = 4] = "Mirror";
})(ResourceType = exports.ResourceType || (exports.ResourceType = {}));
var ResourceIdPrefix;
(function (ResourceIdPrefix) {
    ResourceIdPrefix["Datasheet"] = "dst";
    ResourceIdPrefix["Form"] = "fom";
    ResourceIdPrefix["Dashboard"] = "dsb";
    ResourceIdPrefix["Widget"] = "wdt";
    ResourceIdPrefix["Mirror"] = "mir";
})(ResourceIdPrefix = exports.ResourceIdPrefix || (exports.ResourceIdPrefix = {}));
//# sourceMappingURL=resource_types.js.map